<template>
  <page-header-wrapper>
    <a-card>
      <a-steps :current="current" style="width: 300px">
        <a-step :title="$t('message.transform.firstStep')" />
        <a-step :title="$t('message.transform.secondStep')" />
      </a-steps>
      <a-card
        style="margin-top: 24px"
        :bordered="false"
        :title="$t('message.transform.boundShop')"
        v-if="current === 0"
      >
        <a-list size="large">
          <a-list-item :key="index" v-for="(item, index) in platforms">
            <a-list-item-meta :description="item.description">
              <a-avatar
                slot="avatar"
                size="large"
                shape="square"
                :src="item.picture"
              />
              <a slot="title" @click="getUrl(item)">{{ item.title }}</a>
            </a-list-item-meta>
            <div class="list-content">
              <div slot="actions">
                <a @click="getUrl(item)">{{$t('message.transform.bind')}}</a>
              </div>
            </div>
            <div slot="actions" @mouseover="getAuthData(item.platform)">
              <a-dropdown>
                <a
                >{{$t('message.transform.shopList')}}
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay" id="shopName">
                  <template v-for="shopname in shopNames">
                    <a-menu-item>{{ shopname }}</a-menu-item>
                  </template>
                  <!--                  <a-menu-item>{{item.shop.shopMy}}</a-menu-item>-->
                </a-menu>
              </a-dropdown>
            </div>
          </a-list-item>
        </a-list>
      </a-card>

      <OwnerTransfer v-if="current === 1" />

      <div>
        <a-button type="primary" @click="next()" v-if="current < 1">
          {{$t('message.transform.downStep')}}
        </a-button>
        <a-button type="primary" @click="prev()" v-if="current === 1">
          {{$t('message.transform.upStep')}}
        </a-button>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
// 演示如何使用 this.$dialog 封装 modal 组件
import TaskForm from './TaskForm'
import Info from './Info'
import OwnerTransfer from './OwnerTransfer'
import Lazada from '../../assets/country/LZD2.png'
// import AE from '../../assets/country/AliExpress.png'
import request from '../../utils/request'

// const data = [{
//   title: 'LAZADA',
//   platform: 'LAZADA',
//   shortPlatform: 'LZD',
//   picture: Lazada,
//   description: this.$t('message.transform.lzd.description')
//   // shop: {
//   //   shopPh: 'PH-SHOP',
//   //   shopMy: 'MY-SHOP'
//   // }
// }]
// data.push({
//   title: 'LAZADA',
//   platform: 'LAZADA',
//   shortPlatform: 'LZD',
//   picture: Lazada,
//   description: this.$t('message.transform.lzd.description')
//   // shop: {
//   //   shopPh: 'PH-SHOP',
//   //   shopMy: 'MY-SHOP'
//   // }
// })
// data.push({
//   title: 'AE',
//   platform: 'AEG',
//   shortPlatform: 'AEG',
//   picture: AE,
//   description: 'AE店铺绑定入口'
//   // shop: {
//   //   shopPh: 'AE-SHOP1',
//   //   shopMy: 'AE-SHOP2'
//   // }
// })

export default {
  name: 'StandardList',
  components: {
    TaskForm,
    Info,
    OwnerTransfer
  },
  computed: {
    platforms () {
      let res = []
      res.push({
        title: 'LAZADA',
        platform: 'LAZADA',
        shortPlatform: 'LZD',
        picture: Lazada,
        description: this.$t('message.transform.lzd.description')
      })
      return res
    }
  },
  data () {
    return {
      status: 'all',
      shopNames: [],
      current: 0
    }
  },
  methods: {
    getUrl (item) {
      request({
        url: '/authorization/end/auth?platform=' + item.shortPlatform + '&fromPage=gfc',
        method: 'get'
      })
    },
    getAuthData: function (platform) {
      request({
        url: '/shipper/shopName?platform=' + platform,
        method: 'get'
      }).then((response) => {
        this.shopNames = response.data.data
      })
    },
    next () {
      this.current++
    },
    prev () {
      this.current--
    }
  }
}
</script>

<style lang="less" scoped>
.ant-avatar-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.list-content-item {
  color: rgba(0, 0, 0, 0.45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;

  span {
    line-height: 20px;
  }

  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/gfc/authorization.vue